import React from "react";
import { connect } from "react-redux";

import { SidebarView, st } from "lib/index";

@connect((state) => ({
  currentCompany: state.auth.company.model,
  currentPath: state.app.location && state.app.location.pathname,
}))
export default class SettingsLayout extends React.PureComponent {
  render() {
    const { currentCompany, currentPath, children } = this.props;

    const links = [
      {
        key: "user",
        label: I18n.t("papp.settings.SettingsLayout.user"),
        icon: <i className="icon material-icons">person</i>,
        children: [
          {
            label: I18n.t("papp.settings.SettingsLayout.user_account_settings"),
            path: `/c/${currentCompany.id}/settings/user/account`,
          },
        ],
      },
      {
        key: "company",
        label: I18n.t("papp.settings.SettingsLayout.company"),
        icon: <i className="icon material-icons">business_center</i>,
        children: [
          {
            label: I18n.t("papp.settings.SettingsLayout.company_account_settings"),
            path: `/c/${currentCompany.id}/settings/company/account`,
          },
          {
            label: I18n.t("papp.settings.SettingsLayout.company_members_settings"),
            path: `/c/${currentCompany.id}/settings/company/members`,
            visible: st.authorize("update", currentCompany),
          },
          {
            label: <span className="admin-link"> {I18n.t("papp.settings.SettingsLayout.products_settings")}</span>,
            path: `/c/${currentCompany.id}/settings/company/products`,
            visible:
              currentCompany.supplier &&
              st.authorize("update", currentCompany) &&
              !["company_admin", "company_employee"].includes(st.authorize.member.role),
          },
          {
            label: I18n.t("papp.settings.SettingsLayout.payments_settings"),
            path: `/c/${currentCompany.id}/settings/company/payments`,
            visible:
              (currentCompany.supplier || currentCompany.agent || currentCompany.reseller) &&
              st.authorize("update_payments_settings", currentCompany),
          },
          {
            label: I18n.t("papp.settings.SettingsLayout.stripe"),
            path: `/c/${currentCompany.id}/settings/company/stripe`,
            visible: st.authorize("stripe", currentCompany),
          },
          {
            label: I18n.t("papp.settings.SettingsLayout.billing_settings"),
            path: `/c/${currentCompany.id}/settings/company/billing`,
            visible: st.authorize("update", currentCompany),
          },
        ],
      },
    ];

    if (st.authorize.member.role !== "company_employee") {
      links.push({
        key: "integrations",
        label: I18n.t("papp.settings.SettingsLayout.integrations"),
        icon: <i className="icon material-icons">compare_arrows</i>,
        children: [
          {
            label: I18n.t("papp.settings.SettingsLayout.marketplace_settings"),
            path: `/c/${currentCompany.id}/settings/integrations/marketplace`,
            visible: currentCompany.enable_marketplace && st.authorize("update", currentCompany),
          },
          {
            label: I18n.t("papp.settings.SettingsLayout.saas_settings"),
            path: `/c/${currentCompany.id}/settings/integrations/saas`,
            visible: currentCompany.enable_saas && st.authorize("update", currentCompany),
          },
          {
            label: I18n.t("papp.settings.SettingsLayout.widgets_settings"),
            path: `/c/${currentCompany.id}/settings/integrations/widgets`,
          },
        ],
      });
    }
    return (
      <SidebarView.Container>
        <SidebarView.Sidebar label={I18n.t("papp.settings.SettingsLayout.title")}>
          <SidebarView.Menu links={links} activePath={currentPath} />
        </SidebarView.Sidebar>
        <SidebarView.Content hasSidebar>{children}</SidebarView.Content>
      </SidebarView.Container>
    );
  }
}



// WEBPACK FOOTER //
// ./src/modules/settings/SettingsLayout.jsx